import {getUsersList} from "./services";

export const subscriptionKeys = {};

class Manager {
  constructor() {
    this.subscriptionKeys = subscriptionKeys;
  }

  getUsersList(query = "", options) {
    const q = !query || query === "" ? "*" : query;

    const {promise, cancel} = getUsersList(q, options);

    const _promise = promise.then(({data, headers = {}}) => {
      const {"x-total-hits": totalHits} = headers,
        total = parseInt(totalHits);

      return {
        data: data.map(datum => ({...datum, id: datum["user-id"]})),
        metadata: {
          count: data.length,
          total
        }
      };
    });

    return {promise: _promise, cancel};
  }
}

const Configuration = () => {
  if (!window.atsSecurityRibbonUserManager) {
    window.atsSecurityRibbonUserManager = new Manager();
  }
  return window.atsSecurityRibbonUserManager;
};

export default Configuration();

export const ManagerClass = Manager;
